import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SwagScan, SwagService } from '../../api';

export const SwagRedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  type SwagScanInput = Omit<SwagScan, 'id' | 'redirect_url_with_campaign' | 'redirect_url'>;

  const swagScanData: Partial<SwagScanInput> = Array.from(searchParams.entries()).reduce(
    (acc, [key, value]) => {
      if (key.startsWith('utm_')) {
        acc[key as keyof SwagScanInput] = value;
      }
      return acc;
    },
    {} as Partial<SwagScan>
  );

  const hasUtmCampaign = Boolean(swagScanData.utm_campaign);

  const { data, isLoading, error } = useQuery({
    queryKey: ['swag', swagScanData] as const,
    queryFn: () => SwagService.swagCreate({ requestBody: swagScanData as SwagScan }),
    enabled: hasUtmCampaign,
  }) as { data: SwagScan | undefined; isLoading: boolean; error: Error | null };

  useEffect(() => {
    if (!hasUtmCampaign) {
      window.location.href = 'https://www.senditgigs.com';
      return;
    }

    if (data) {
      // Save scan ID to localStorage before redirecting
      if (data.id) {
        localStorage.setItem('attributionSwagScanId', data.id);
      }
      if (data.redirect_url.includes('http')) {
        window.location.href = data.redirect_url_with_campaign;
        return;
      }
      navigate(data.redirect_url_with_campaign || '/', { replace: true });
    }
  }, [data, navigate, hasUtmCampaign]);

  if (error) {
    navigate('/error', { replace: true });
    return null;
  }

  return isLoading ? (
    <Spinner
      aria-label="loading indicator"
      animation="grow"
      className="loading-spinner"
      variant="primary"
    />
  ) : null;
};
